import { render, staticRenderFns } from "./CommunityDescriptionForm.vue?vue&type=template&id=0cfbc995&"
import script from "./CommunityDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./CommunityDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports